import { OpenMode, useLocalStorageForm } from "@onesolution/components";
import type { TagsFilters } from "@onesolution/utils/makeTagsFilters";
import { useEffect } from "react";
import { useDebounceValue } from "usehooks-ts";

export function makeDefaultOpFilters(status?: string[]) {
	return {
		status: status || [],
		type: [],
	} as TagsFilters;
}

export function useTagsFilters(key: string, additionalFilters?: object) {
	const form = useLocalStorageForm<TagsFilters>({
		mode: OpenMode.edition,
		localStorageKey: `@onevision-tags-filters-${key}`,
		defaultValues: {
			...makeDefaultOpFilters(),
			...(additionalFilters || {}),
		},
		onSuccess: () => null,
		onSubmitMutation: () => null,
	});
	const [debouncedFilters, updateDebouncedFilters] = useDebounceValue(
		form.state.values,
		500,
	);

	useEffect(() => {
		updateDebouncedFilters(form.state.values);
	}, [form.state.values, updateDebouncedFilters]);

	return { form, filters: debouncedFilters };
}
